(function () {
  "use strict";

  function collectionCard() {
    const copyElement = document.getElementById("lkc-accessibility-copy");
    const copy = copyElement ? JSON.parse(copyElement.textContent) : {};
    const cardLabels = copy.promoCards || {};
    const mainContainer = document.querySelector(".collection-products");
    if (!mainContainer || mainContainer.querySelector(".collection-pvc-card")) {
      return;
    }

    const productCard = Array.from(mainContainer.children);

    if (!productCard.length) {
      return;
    }

    ///////////////////////////DATA STARTS HERE/////////////////////////////////////

    const IMAGE = [ 
      {
        IMAGE:
          "//cdn.shopify.com/s/files/1/0549/8005/1111/files/VPC_HIMAWARIHORRORS.webp",
        LINK: "/collections/himawarikeep",
      },
      {
        IMAGE:
          "//cdn.shopify.com/s/files/1/0549/8005/1111/files/VPC_SWOOPYBOYHOODIE.webp?v=1778650508",
        LINK: "/collections/sale",
      },
      {
        IMAGE:
          "//cdn.shopify.com/s/files/1/0549/8005/1111/files/VPC-KirstyMcIntyre.webp?v=1771397909",
        LINK: "/collections/kirsty-mcintyre",
        WIDTH: 1415,
      },
      {
        IMAGE:
          "//cdn.shopify.com/s/files/1/0549/8005/1111/files/VPCEveryBodyWins.webp?v=1721882526",
        LINK: "/collections/all",
      },
      {
        IMAGE:
          "//cdn.shopify.com/s/files/1/0549/8005/1111/files/VPC_HATS.webp?v=1766543261",
        LINK: "/collections/headwear",
      },
      {
        IMAGE:
          "//cdn.shopify.com/s/files/1/0549/8005/1111/files/VPC_AnnieWalter.webp?v=1757049289",
        LINK: "/collections/annie-walter",
      },
    ];

    ////////////////////////DATA ENDS HERE//////////////////////////////////

    let style = document.getElementById("convx-value-proposition-style");
    if (!style) {
      style = document.createElement("style");
      style.id = "convx-value-proposition-style";
    style.textContent = `
    .convx__value-proposition-cards-link{
      position: absolute;
      inset: 0;
      display: block;
      height: 100%;
      width: 100%;
      border: 2px solid #000;
      overflow: hidden;
    }
    .convx__value-proposition-cards-img{
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }
    @media not all and (max-width: 992px){
      .collection-pvc-card--mobile-only{
        display: none;
      }
    }
    `;
      document.head.append(style);
    }

    shuffle(IMAGE);
    shuffle(IMAGE);
    if (productCard.length < 5) {
      productCard[Math.min(6, productCard.length - 1)].before(
        createImgCard(IMAGE[0])
      );
    } else if (productCard.length < 16) {
      productCard[Math.min(6, productCard.length - 1)].before(
        createImgCard(IMAGE[0])
      );
    } else if (productCard.length < 24) {
      productCard[Math.min(6, productCard.length - 1)].before(
        createImgCard(IMAGE[0])
      );
      productCard[Math.min(11, productCard.length - 1)].before(
        createImgCard(IMAGE[1])
      );
    } else if (productCard.length >= 24) {
      productCard[Math.min(6, productCard.length - 1)].before(
        createImgCard(IMAGE[0])
      );
      productCard[Math.min(11, productCard.length - 1)].before(
        createImgCard(IMAGE[1])
      );
      productCard[Math.min(16, productCard.length - 1)].before(
        createImgCard(IMAGE[2])
      );
      productCard[Math.min(20, productCard.length - 1)].before(
        createImgCard(IMAGE[3], true)
      );
    }

    // productCard[Math.min(6, productCard.length - 1)].before(
    //   createImgCard(IMAGE[0])
    // );
    // productCard[Math.min(11, productCard.length - 1)].before(
    //   createImgCard(IMAGE[1])
    // );
    // productCard[Math.min(16, productCard.length - 1)].before(
    //   createImgCard(IMAGE[2])
    // );

    function createImgCard(ITEM, mobileOnly = false) {
      const div = document.createElement("div");
      div.classList.add(
        "spf-col-xl-4",
        "spf-col-lg-4",
        "spf-col-md-6",
        "spf-col-sm-6",
        "spf-col-6",
        "collection-pvc-card"
      );
      if (mobileOnly) {
        div.classList.add("collection-pvc-card--mobile-only");
      }

      const div2 = document.createElement("div");
      div2.classList.add(
        "spf-product-card",
        "spf-product-card__left",
        "spf-product-card__template-1"
      );

      const a = document.createElement("a");
      a.classList.add("convx__value-proposition-cards-link");
      a.setAttribute("href", ITEM.LINK);

      const img = document.createElement("img");
      img.classList.add("convx__value-proposition-cards-img");
      img.setAttribute("alt", cardLabels[ITEM.LINK] || ITEM.LINK.split("/").pop().replace(/-/g, " "));
      img.setAttribute("loading", "lazy");
      img.setAttribute("decoding", "async");
      img.setAttribute("sizes", "(min-width: 992px) 380px, calc(50vw - 20px)");
      img.setAttribute("srcset", [400, 800, 1200, Math.min(1600, ITEM.WIDTH || 1600)].map((width) => {
        const url = new URL(ITEM.IMAGE, window.location.href);
        url.searchParams.set("width", String(width));
        return `${url.href} ${width}w`;
      }).join(", "));
      const fallbackUrl = new URL(ITEM.IMAGE, window.location.href);
      fallbackUrl.searchParams.set("width", "800");
      img.setAttribute("src", fallbackUrl.href);

      a.append(img);
      div2.append(a);
      div.append(div2);

      return div;
    }

    function shuffle(array) {
      array.sort(() => Math.random() - 0.5);
    }
  }

  let pendingInsertion;

  function onDOMContentLoaded() {
    const observer = new MutationObserver(onMutate);
    observer.observe(document.documentElement, {
      attributes: true,
      attributesFilter: ["class"],
    });
    if (document.documentElement.classList.contains("spf-status-loaded")) {
      scheduleInsertion();
    }
  }

  function scheduleInsertion() {
    clearTimeout(pendingInsertion);
    pendingInsertion = setTimeout(collectionCard, 200);
  }

  function onMutate(mutationList, observer) {
    const mainContainer = document.querySelector(".collection-products");
    const card = mainContainer && mainContainer.querySelector(".collection-pvc-card");
    for (const mutation of mutationList) {
      if (
        mutation.target.classList.contains("spf-status-loaded") &&
        !card
      ) {
        scheduleInsertion();
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onDOMContentLoaded, {
      once: true,
    });
  } else {
    onDOMContentLoaded();
  }
})();
